/** Matches backend USE_HTTPONLY_AUTH_COOKIE (default on in production builds). */
export function isHttpOnlyAuthSessionEnabled(): boolean {
  const override = (process.env.REACT_APP_USE_HTTPONLY_AUTH_COOKIE || '').trim().toLowerCase();
  if (override === 'true') return true;
  if (override === 'false') return false;
  return process.env.NODE_ENV === 'production';
}

export type AuthSessionUser = {
  id: string;
  username: string;
  role: string;
  enterprise_id?: string;
};

let sessionUser: AuthSessionUser | null = null;

/** In-memory user for cookie sessions (audit logging, theme, etc.). */
export function setAuthSessionUser(user: AuthSessionUser | null): void {
  sessionUser = user;
  if (user) {
    sessionStorage.setItem('turboiam-session-active', '1');
  } else {
    sessionStorage.removeItem('turboiam-session-active');
  }
  window.dispatchEvent(new Event('authChanged'));
}

export function getAuthSessionUser(): AuthSessionUser | null {
  return sessionUser;
}

export function isAuthSessionActive(): boolean {
  if (isHttpOnlyAuthSessionEnabled()) {
    return sessionStorage.getItem('turboiam-session-active') === '1' || !!sessionUser;
  }
  return !!localStorage.getItem('token');
}

/** True when JWT is present (legacy) or cookie session is active. */
export function hasAuthSession(): boolean {
  return isAuthSessionActive();
}

export function getAuthToken(): string | null {
  if (isHttpOnlyAuthSessionEnabled()) return null;
  return localStorage.getItem('token');
}

export function getAuthHeaders(extra?: Record<string, string>): Record<string, string> {
  const headers: Record<string, string> = { ...extra };
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export function authFetchInit(init: RequestInit = {}): RequestInit {
  const headers = new Headers(init.headers as HeadersInit | undefined);
  if (!isHttpOnlyAuthSessionEnabled()) {
    const token = getAuthToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  }
  return {
    ...init,
    credentials: isHttpOnlyAuthSessionEnabled() ? 'include' : init.credentials,
    headers,
  };
}
